module.exports = __webpack_public_path__ + "media/images/buttons/apple-download-06c0594f33d438b3ed4680eef41f8e58.svg";